import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { tap, filter } from 'rxjs/operators';
import { RouterNavigateAction, RefreshPageAction } from './actions';

@Injectable()
export class RouteEffects {

  constructor(private router: Router, private actions$: Actions<any>) { }

  routerNavigate$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RouterNavigateAction>(RouterNavigateAction.ROUTER_NAVIGATE),
      tap(action => {
        if (Array.isArray(action.options.url)) {
          this.router.navigate(action.options.url, action.options.extras);
        } else {
          this.router.navigateByUrl(action.options.url, action.options.extras);
        }
      })
    ),
    { dispatch: false }
  );

  refreshPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<RefreshPageAction>(RefreshPageAction.REFRESH_PAGE),
      filter(() => location != null && location.reload != null),
      tap(() => location.reload())
    ),
    { dispatch: false }
  );
}
